
import {takeUntil} from 'rxjs/operators';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { CutimedService } from './Cutimed.service';
import { ICutimedSegment } from '../../../model/product/tena/cutimed/ICutimedSegment';
import { ICutimedWebShopCatalogApi } from '../../../model/product/tena/cutimed/ICutimedWebShopCatalogApi';

@Component({
    selector: 'admin-cutimed-country-segment-menu',
    templateUrl: 'CutimedCountrySegmentMenu.component.html'
})
export class CutimedCountrySegmentMenuComponent implements OnInit, OnDestroy {
    countryModalVisible: boolean;
    segmentModalVisible: boolean;
    country: ICutimedWebShopCatalogApi;
    segment: ICutimedSegment;

    @Input()
    useSegment = true;

    private unsubscribe: Subject<void> = new Subject();

    constructor(private cutimedService: CutimedService) {}

    ngOnInit() {
        // First show country popup and then segment popup.
        this.initializeCountryModal();
    }

    initializeCountryModal(): void {
        this.cutimedService.countryModalVisible.pipe(
            takeUntil(this.unsubscribe))
            .subscribe(visible => {
                this.countryModalVisible = visible;
            });

        this.cutimedService.countryChanged.pipe(takeUntil(this.unsubscribe)).subscribe(country => {
            if (country) {
                this.country = country;

                if (this.useSegment) {
                    // Now show segment popup
                    this.initializeSegmentModal();
                }
            }
        });

        let sessionStorageCountry = this.cutimedService.getActiveCountry();
        if (sessionStorageCountry) {
            this.cutimedService.countryChanged.next(sessionStorageCountry);
            this.cutimedService.countryModalVisible.next(false);
        } else {
            this.cutimedService.countryModalVisible.next(true);
        }
    }

    initializeSegmentModal(): void {
        this.cutimedService.segmentModalVisible.pipe(
            takeUntil(this.unsubscribe))
            .subscribe(visible => {
                this.segmentModalVisible = visible;
            });

        this.cutimedService.segmentChanged.pipe(takeUntil(this.unsubscribe)).subscribe(segment => {
            if (segment) {
                this.segment = segment;
            }
        });

        let sessionStorageSegment = this.cutimedService.getActiveSegment();
        if (sessionStorageSegment) {
            this.cutimedService.segmentChanged.next(sessionStorageSegment);
            this.cutimedService.segmentModalVisible.next(false);
        } else {
            this.cutimedService.segmentModalVisible.next(true);
        }
    }

    selectSegment() {
        this.cutimedService.segmentModalVisible.next(true);
    }

    selectCountry() {
        this.cutimedService.countryModalVisible.next(true);
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
